import { useState, useEffect } from "react";
import { Location } from "@/types/trip";
import useTripStore from "@/stores/tripBuilder/useTrip";
import logger from "@/utils/logger";
export const useLocationData = () => {
  const { tripData, selectedLocation } = useTripStore();
  const [previousLocation, setPreviousLocation] = useState<Location | null>(
    null
  );
  const [nextLocation, setNextLocation] = useState<Location | null>(null);
  const [isOrigin, setIsOrigin] = useState(false);
  const [isLastLocation, setIsLastLocation] = useState(false);
  const [isFirstLocation, setIsFirstLocation] = useState(false);

  useEffect(() => {
    if (!selectedLocation || !tripData) {
      logger.log("No selected location or trip data");
      return;
    }

    const currentLocation = tripData.locations.find(
      (location) => location.id === selectedLocation.id && !location.origin
    );

    if (!currentLocation) return;

    const selectedLocationIndex = tripData.locations.indexOf(currentLocation);

    const prevLocation =
      selectedLocationIndex > 0
        ? tripData.locations[selectedLocationIndex - 1]
        : null;

    const nextLoc =
      selectedLocationIndex < tripData.locations.length - 1
        ? tripData.locations[selectedLocationIndex + 1]
        : null;

    const currentBudget = currentLocation?.budget || 0;

    // // arrival date is either start_date or flight arrival date
    // const locationFlight = tripData?.flights?.filter(
    //   (flight) => flight.toLocationId === selectedLocation?.id
    // );
    // const effectiveArrivalDate = locationFlight.flightInfo..

    setPreviousLocation(prevLocation!);
    setNextLocation(nextLoc!);
    setIsOrigin(selectedLocationIndex === 0);
    setIsLastLocation(selectedLocationIndex === tripData.locations.length - 1);
    setIsFirstLocation(selectedLocationIndex === 1);
  }, [selectedLocation, tripData]);

  return {
    selectedLocation,
    previousLocation,
    nextLocation,
    isOrigin,
    isLastLocation,
    isFirstLocation,
  };
};
